export default __webpack_public_path__ + "static/media/image3.0f283e45.jpg";